import { useTranslation } from 'react-i18next';
import {
  ModalOverlay,
  PhoneCallIcon,
  Loader,
  SentaraLogo
} from '@sentara-health/optimahealth_web';
import { VirtualVisitModalBox } from 'templates';
import { CARE_COORDINATOR_PHONE_NUMBER } from 'common';
import { useVirtualPopUpHooks } from './hooks/VirtualPopUpHooks';

interface MyCareCoordinatorPopUpProps {
  closeModal: () => void;
}
function MyCareCoordinatorPopUp({
  closeModal
}: Readonly<MyCareCoordinatorPopUpProps>) {
  // Initialize translation hook
  const { t } = useTranslation();

  const careCoordinatorAssistList = t(
    'virtualVisitCare.MyCareCoordinator.sentaraContent.assistList',
    { returnObjects: true }
  ) as string[];

  const sentaraDisclaimerList = [
    { text: t('virtualVisitCare.MyCareCoordinator.sentaraContent.disclaimerNote1'), style: 'mt-3' },
    { text: t('virtualVisitCare.MyCareCoordinator.sentaraContent.disclaimerNote2'), style: 'mt-2' },
    { text: t('virtualVisitCare.MyCareCoordinator.sentaraContent.disclaimerNote3'), style: 'mt-2' },
  ];

  const careCoordinatorContent = (
    <>
      <p>{t('virtualVisitCare.MyCareCoordinator.sentaraContent.careCoordinatorContent')}</p>
      <p className="mt-2 mb-1">
        {t('virtualVisitCare.MyCareCoordinator.sentaraContent.assistTitle')}
      </p>
      <ul className="ps-4 mb-0">
        {careCoordinatorAssistList.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </>
  );

  const myCareCoordinatorPopUpHooks = useVirtualPopUpHooks();

  return (
    <>
      <ModalOverlay
        className="virtual-visit-box"
        data-testid={'myCareCoordinatorModalId'}
        isOpen
        onClose={closeModal}
        overlayInfo="my care coordinator"
      >
        <div className="curved-box-single-box gap-4 w-100">
          <VirtualVisitModalBox
            logoImage={<SentaraLogo />}
            title={t('virtualVisitCare.sentaraHealthTitle')}
            subtitle={t('virtualVisitCare.MyCareCoordinator.sentaraContent.myCareCoordinator')!}
            badgeImage={<PhoneCallIcon />}
            content={careCoordinatorContent}
            buttonLabel={t('virtualVisitCare.MyCareCoordinator.sentaraContent.buttonText')}
            buttonTestId="careCoordinatorCallButton"
            buttonOnClick={() => {
              myCareCoordinatorPopUpHooks.PhoneNumberLink({
                phoneNumber: CARE_COORDINATOR_PHONE_NUMBER
              });
            }}
            displayBlock={true}
            minHeight={'200'}
            disclaimers={sentaraDisclaimerList}
          />
        </div>
      </ModalOverlay>
      {myCareCoordinatorPopUpHooks?.loading ? <Loader /> : null}
    </>
  );
}

export default MyCareCoordinatorPopUp;